import { Controller } from "@hotwired/stimulus"

// Human message requests are separate from the twin chat. Access to the
// receipt is restricted to the browser session that submitted the request.
export default class extends Controller {
  static targets = ["initial", "conversation", "thread", "status", "reply", "error", "scroll"]
  static values = { url: String }

  disconnect() { clearInterval(this.timer) }

  // Polls only while there is a request from this browser to watch: with
  // none (404 - most visitors, and the owner) one check is enough, until
  // they send one.
  async open() {
    this._open = true
    if (await this.refresh()) this._poll()
  }

  close() {
    this._open = false
    clearInterval(this.timer)
  }

  _poll() {
    clearInterval(this.timer)
    if (this._open) this.timer = setInterval(() => this.refresh(), 10000)
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (response.status === 404) {
        clearInterval(this.timer)
        return false
      }
      if (response.ok) this.render(await response.json())
    } catch (_) { /* Keep the current conversation while offline. */ }
    return true
  }

  async send(event) {
    event.preventDefault()
    const form = event.target
    const button = form.querySelector('[type="submit"]')
    button.disabled = true
    this.errorTarget.textContent = ""
    try {
      const response = await fetch(form.action, {
        method: "POST", body: new FormData(form),
        headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" }
      })
      const result = await response.json()
      if (!response.ok || !result.ok) throw new Error(result.error || "Could not send. Please try again.")
      this._poll()
      if (!result.messages) {
        this.statusTarget.textContent = "Request sent."
        return
      }
      this.render(result)
      form.reset()
    } catch (error) {
      this.errorTarget.textContent = error.message || "Could not send. Please try again."
    } finally { button.disabled = false }
  }

  render(result) {
    const trigger = document.querySelector("[data-profile-visitor-request]")
    if (trigger) {
      const label = { pending: "Request sent", accepted: "Message", declined: "Request closed" }[result.status]
      trigger.querySelector(".bi-chat")?.toggleAttribute("hidden", label !== "Message")
      const text = trigger.querySelector("span")
      text ? (text.textContent = label) : (trigger.textContent = label)
    }
    this.initialTarget.hidden = true
    this.conversationTarget.hidden = false
    this.replyTarget.hidden = !result.can_reply
    this.statusTarget.textContent = result.status === "accepted" ? (result.can_reply ? "Request accepted. You can continue this conversation here." : "This conversation is currently read-only.")
      : result.status === "declined" ? "This message request has been closed."
        : "Request sent — pending acceptance. You can still explore Ask questions on the page."
    // The Jane chat's bubbles: yours on the right, the owner's on the left.
    this.threadTarget.replaceChildren(...result.messages.map(message => {
      const bubble = document.createElement("div")
      bubble.className = `assistant-bubble ${message.author === "visitor" ? "assistant-bubble-user" : "assistant-bubble-assistant"}`
      bubble.textContent = message.body
      return bubble
    }))
  }
}
